import React, { useEffect, useState, useRef } from 'react';
import { Navigate } from 'react-router-dom';
import TR from '../../Trans';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import ErrorDialog from '../dialogs/ErrorDialog';
import { GlobalStyles } from "@mui/material";
import backgroundImage from "../../assets/people-group-4-square.jpg";
import Box from '@mui/material/Box';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { useLocalStorage } from '../../services/useLocalStorage';
import { useNavigate } from "react-router-dom";
import { ReactComponent as MuvikaLogo } from './../../assets/logo.svg';
import { ReactComponent as MuvikaLogoInv } from './../../assets/logo-horiz-inv.svg';
import { ReactComponent as MuvikaLogoProInv } from './../../assets/logo-horiz-pro-inv.svg';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IosExternalLinkDialog from '../dialogs/IosExternalLinkDialog';
import CssBaseline from '@mui/material/CssBaseline';
import { Capacitor } from '@capacitor/core';
import TermsDialog from '../dialogs/TermsDialog';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import InputLabel from '@mui/material/InputLabel';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import OutlinedInput from '@mui/material/OutlinedInput';
import ThemeToggleButton from '../items/ThemeToggleButton';
import IconButton from '@mui/material/IconButton';
import FacebookLoginDialog from '../dialogs/FacebookLoginDialog';
import InputAdornment from '@mui/material/InputAdornment';
import Error from '../items/Error';
import ChooseLanguage from '../items/ChooseLanguage';
import Message from '../items/Message';
import Container from '@mui/material/Container';
import Waiting from '../items/Waiting';
import sessionStore from '../../stores/session';
import messageStore from '../../stores/message';
import statusStore from '../../stores/status';
import accountStore from '../../stores/account';
import { Logout } from '@mui/icons-material';
import MuvikaService from '../../services/muvika';
import IntervalService from '../../services/intervals';
import navigationStore from '../../stores/navigation';
import performanceStore from '../../stores/performance';
import settingsStore from '../../stores/settings';
import singersStore from '../../stores/singers';
import EditPerformance from '../dialogs/EditPerformance';
import newTracksStore from '../../stores/newTracks';
import favoritesStore from '../../stores/favorites';
import catalogStore from '../../stores/catalog';
import environmentStore from '../../stores/environment';
import musicStore from '../../stores/music';
import musicPlayerStore from '../../stores/musicPlayer';
import newsStore from '../../stores/news';
import playerStore from '../../stores/player';
import searchStore from '../../stores/search';
import songListStore from '../../stores/songList';
import singerStore from '../../stores/singers';
import timeoutsStore from '../../stores/timeouts';
import homeStore from '../../stores/home';
import SubscribeDialog from '../dialogs/SubscriptionDialog';
import UpdateDialog from '../dialogs/UpdateDialog';
import MessageDialog from '../dialogs/MessageDialog';
import { AndroidExternalScreen } from 'muvika-android-external-screen';
import muvikaAttrs from '../../attrs';
import bgFiltersStore from '../../stores/bgFilters';
import bgStylesStore from '../../stores/bgStyles';
import bgPerformanceStore from '../../stores/bgPerformance';
import bgSearchStore from '../../stores/bgSearch';
import bgPlaylistsStore from '../../stores/bgPlaylists';
import songbookQueueStore from '../../stores/songbookQueue';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    background: {
      default: "var(--back-color)"
    }
  },
});

function resetStores() {
  accountStore.getState().reset();
  catalogStore.getState().reset();
  environmentStore.getState().reset();
  favoritesStore.getState().reset();
  messageStore.getState().reset();
  musicPlayerStore.getState().reset();
  musicStore.getState().reset();
  navigationStore.getState().reset();
  newsStore.getState().reset();
  homeStore.getState().reset();
  newTracksStore.getState().reset();
  performanceStore.getState().reset();
  playerStore.getState().reset();
  searchStore.getState().reset();
  sessionStore.setState({
    isSessionOpening: false,
    isThrownOut: false,
    isLoggedIn: false,
    isAckSmartQ: false,
    externalWindowHandler: null,
    isLoginSeqErrors: false,
    isLoginSeqError: false,
    isWaiting: false,
    requestCount: 0,
    isWaitingLoggedIn: false,
    isAndroidSubMode: false
  });
  settingsStore.getState().reset();
  singersStore.getState().reset();
  songListStore.getState().reset();
  timeoutsStore.getState().reset();
  IntervalService.clearAllIntervals();
  IntervalService.clearSongbookInterval();
  IntervalService.clearNewTracksInterval();
  IntervalService.clearAllStreamUrlTimeouts();
  IntervalService.clearSubInterval();
  bgFiltersStore.getState().reset();
  bgStylesStore.getState().reset();
  bgPerformanceStore.getState().reset();
  bgSearchStore.getState().reset();
  bgPlaylistsStore.getState().reset();
  musicPlayerStore.getState().reset();
  
}

function ForceChangePassword() {

  useEffect(() => {
    document.documentElement.style.fontSize = "16px";
    window.dispatchEvent(new Event('refitbuttons'));
    window.dispatchEvent(new Event('resize'));
  }, []);

  const sessionToken = sessionStore((state) => state.sessionToken);
  const getAccount = accountStore((state) => state.getAccount);
  const setAccount = accountStore((state) => state.setAccount);
  const account = accountStore((state) => state.account);
  const environment = environmentStore((state) => state.environment);
  const clearAccountStore = accountStore((state) => state.clearAll);
  const logout = sessionStore((state) => state.logout);
  const isSessionOpen = sessionStore((state) => state.isSessionOpen);
  const isLoggedIn = sessionStore((state) => state.isLoggedIn);
  const setError = messageStore((state) => state.setError);
  const setMessage = messageStore((state) => state.setMessage);
  const updateSession = sessionStore((state) => state.updateSession);


  const handleChangePassword = (oldPassword, newPassword1, newPassword2) => {
    if (oldPassword.length == 0 ||
      newPassword1.length == 0 ||
      newPassword2.length == 0) {
      setError(sessionToken, 0, TR.cm_fill_all_fields);
      return;
    }
    if (newPassword1.length >= 8) {
      if (newPassword1 === newPassword2) {
        MuvikaService.changePassword(sessionToken, account.username, oldPassword, newPassword1)
          .then(function (res) {
            if (res.data.error) {
              messageStore.getState().setError(sessionToken, res.data.error.code, res.data.error.details.length > 0 ? res.data.error.details : res.data.error.string);
            } else {
              getAccount(sessionToken);
              messageStore.getState().setMessage(sessionToken, TR.ww_password_changed);
            }
          })
          .catch(function () { });
      } else {
        setError(sessionToken, 0, TR.ww_passwords_must_match);
      }
    } else {
      setError(sessionToken, 0, TR.ww_password_too_short);
    }
  };

  const [oldPassword, setOldPassword] = useState("");
  const [newPassword1, setNewPassword1] = useState("");
  const [newPassword2, setNewPassword2] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword1, setShowNewPassword1] = useState(false);
  const [showNewPassword2, setShowNewPassword2] = useState(false);

  useEffect(() => {
    if (!account) {
      getAccount(sessionToken);
    }
  }, []);

  const handleChange = () => {
    handleChangePassword(oldPassword, newPassword1, newPassword2);

  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      handleChange();
    }
  };

  const renderPassword = () => {
    if (account) {
      if (account.force_pw_change) {
        return <Box component="form" noValidate sx={{ width: "90%", paddingBottom: 1 }}>
          <InputLabel>{TR.cm_current_password}</InputLabel>
          <OutlinedInput
            id="old-password"
            variant="outlined"
            margin="normal"
            required
            size="small"
            fullWidth
            value={oldPassword}
            notched={false}
            label={TR.cm_current_password}
            onChange={(e) => setOldPassword(e.target.value)}
            type={showOldPassword ? 'text' : 'password'}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowOldPassword(!showOldPassword)}
                  onMouseDown={() => setShowOldPassword(!showOldPassword)}
                  edge="end"
                >
                  {showOldPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
          <InputLabel>{TR.cm_new_password}</InputLabel>
          <OutlinedInput
            id="new-password1"
            variant="outlined"
            margin="normal"
            required
            size="small"
            fullWidth
            value={newPassword1}
            notched={false}
            label={TR.cm_new_password_again}
            onChange={(e) => setNewPassword1(e.target.value)}
            type={showNewPassword1 ? 'text' : 'password'}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowNewPassword1(!showNewPassword1)}
                  onMouseDown={() => setShowNewPassword1(!showNewPassword1)}
                  edge="end"
                >
                  {showNewPassword1 ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
          <InputLabel>{TR.cm_new_password_again}</InputLabel>
          <OutlinedInput
            id="new-password2"
            variant="outlined"
            margin="normal"
            size="small"
            required
            fullWidth
            value={newPassword2}
            notched={false}
            label={TR.cm_new_password_again}
            onChange={(e) => setNewPassword2(e.target.value)}
            type={showNewPassword2 ? 'text' : 'password'}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowNewPassword2(!showNewPassword2)}
                  onMouseDown={() => setShowNewPassword2(!showNewPassword2)}
                  edge="end"
                >
                  {showNewPassword2 ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
          />
        </Box>;
      }
    }
  };

  const [theme, setTheme] = useLocalStorage(muvikaAttrs.service + "-theme", "dark");

  const renderLogo = () => {
    if (!theme || theme === "dark") {
      return <MuvikaLogo className="muvika-logo-login-svg" />;
    } else {
      return <MuvikaLogoInv className="muvika-logo-login-svg" />;
    }
  };

  const renderLoggedIn = () => {
    if (isSessionOpen && isLoggedIn) {
      if (account) {
        if (account.force_pw_change) {
          return <Box
            className="muvika-entry-box"
          >
            <p>
              {renderLogo()}
            </p>
            <p>
              {TR.cm_change_password}
            </p>
            {renderPassword()}
            <Stack direction="row" spacing={6} justifyContent="center">
              <Button variant="text" color="secondary" onClick={() => {
                resetStores();
                logout();
              }}>{TR.cm_cancel}</Button>
              <Button
                variant="text"
                color="success"
                onClick={handleChange}
              >
                {TR.cm_save}
              </Button>
            </Stack>
            <ThemeToggleButton />
          </Box>;
        } else {
          if (account) {
            if (account.force_accept_terms) {
              return <Navigate to="/forceacceptterms" />;
            }
          }
          return <Navigate to="/" />;
        }
      }
    } else {
      if (account) {
        if (account.force_accept_terms) {
          return <Navigate to="/forceacceptterms" />;
        }
      }
      return <Navigate to="/" />;
    }
  };

  const overflowStyleIos = `
  html {
    overflow-y:scroll !important;
  }
  
  body {
    overflow-y:scroll !important;
  }
  
  main {
    overflow-y:scroll !important;
  }
`;

  const overflowStyle = `
  html {
    overflow-y:auto !important;
  }
  
  body {
    overflow-y:auto !important;
  }
  
  main {
    overflow-y:auto !important;
  }
`;

  const renderOverflowStyle = () => {
    if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
      return <style>
        {overflowStyleIos}
      </style>;
    } else {
      return <style>
        {overflowStyle}
      </style>;
    }
  };

  return (
    <ThemeProvider theme={darkTheme}>
      {renderOverflowStyle()}
      <GlobalStyles
        styles={{
          body: {
            margin: 0,
            minHeight: "100vh",
            minWidth: "100vw",
            backgroundImage: `url(${backgroundImage}) !important`,
            backgroundRepeat: "no-repeat !important",
            backgroundSize: "cover !important",
            backgroundPosition: "center !important",
          },
        }}
      />
      <Container component="main" className="muvika-entry-container" maxWidth="xs" onKeyDown={handleKeyDown}>
        <CssBaseline />
        <Error />
        <Message />
        {renderLoggedIn()}
      </Container>
    </ThemeProvider>
  );
};

export default ForceChangePassword;